import vars from "../helpers";

const init = () => {
	const $module = $('.footer-home');

	if (vars.isMobile()) {
		let $infoTeam = $module.find('.footer-home__info__team button');
		let $team = $module.find('.footer-home__team');
		let $close = $module.find('.footer-home__team__close');

		$infoTeam.on('click', () => {
			$team.addClass('is-show-team');
		});

		$close.on('click', () => {
			$team.removeClass('is-show-team');
		});
	}
}

export default {
	init,
}
